/* __next_internal_client_entry_do_not_use__ Avatar auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircularProgress, Menu } from "__barrel_optimize__?names=CircularProgress,Menu!=!@mui/material";
import React from 'react';
import { logOut } from '@/lib/firebase/client-auth';
import { useRouter } from 'next/navigation';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DefaultProfile from '@/app/img/default-avatar.webp';
export function Avatar(param) {
    let { user } = param;
    var _user_userData, _user_userData1;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [logoutLoading, setLogoutLoading] = React.useState(false);
    const open = Boolean(anchorEl);
    const handleClick = (event)=>{
        setAnchorEl(event.currentTarget);
    };
    const handleClose = ()=>{
        setAnchorEl(null);
    };
    const router = useRouter();
    const handleLogout = async ()=>{
        setLogoutLoading(true);
        await logOut().then(()=>{
            router.replace('/');
        }).then(()=>{
            setLogoutLoading(false);
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center",
        children: [
            /*#__PURE__*/ _jsx("button", {
                id: "profile-menu-button",
                "aria-controls": open ? 'profile-menu' : undefined,
                "aria-haspopup": "true",
                "aria-expanded": open ? 'true' : undefined,
                onClick: handleClick,
                className: "h-10 w-10 rounded-full mr-5 p-[2px] border-2 border-cyan",
                children: /*#__PURE__*/ _jsx("img", {
                    src: (user === null || user === void 0 ? void 0 : user.currentUser.photoURL) || DefaultProfile.src,
                    className: "w-full h-full object-cover rounded-full",
                    alt: "profile avater"
                })
            }),
            /*#__PURE__*/ _jsxs(Menu, {
                id: "profile-menu",
                anchorEl: anchorEl,
                open: open,
                onClose: handleClose,
                MenuListProps: {
                    'aria-labelledby': 'basic-button'
                },
                transformOrigin: {
                    horizontal: 'right',
                    vertical: 'top'
                },
                anchorOrigin: {
                    horizontal: 'right',
                    vertical: 'bottom'
                },
                slotProps: {
                    paper: {
                        elevation: 0,
                        sx: {
                            overflow: 'visible',
                            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.10))',
                            mt: 1.5,
                            width: 220,
                            border: '1px solid',
                            borderColor: 'rgb(212 212 212)',
                            '& .MuiAvatar-root': {
                                width: 32,
                                height: 32,
                                ml: -0.5,
                                mr: 1
                            }
                        }
                    }
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "py-3 flex flex-col items-center border-b border-neutral-300",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                children: (user === null || user === void 0 ? void 0 : user.currentUser.photoURL) ? /*#__PURE__*/ _jsx("img", {
                                    src: (user === null || user === void 0 ? void 0 : user.currentUser.photoURL) || DefaultProfile.src,
                                    alt: "User Photo",
                                    className: "h-10 w-10 rounded-full object-cover"
                                }) : /*#__PURE__*/ _jsx(AccountCircleIcon, {
                                    fontSize: "small"
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ _jsxs("p", {
                                    className: "text-sm font-medium",
                                    children: [
                                        user === null || user === void 0 ? void 0 : user.userData.first_name,
                                        " ",
                                        user === null || user === void 0 ? void 0 : user.userData.last_name
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "px-3 pt-3 pb-1",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: (user === null || user === void 0 ? void 0 : (_user_userData = user.userData) === null || _user_userData === void 0 ? void 0 : _user_userData.user_type) === 'Customer' ? '/customer' : '/admin',
                                    className: "bg-cyan text-xs font-medium text-center w-full rounded-md p-2 text-white",
                                    children: (user === null || user === void 0 ? void 0 : (_user_userData1 = user.userData) === null || _user_userData1 === void 0 ? void 0 : _user_userData1.user_type) === 'Customer' ? 'Book an Inspection' : 'Dashboard'
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "mt-2",
                                children: /*#__PURE__*/ _jsx("button", {
                                    onClick: handleLogout,
                                    className: "border-neutral-300 text-xs font-medium border text-center w-full rounded-md p-2",
                                    children: logoutLoading ? /*#__PURE__*/ _jsx(CircularProgress, {
                                        size: 12
                                    }) : 'Logout'
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
